import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { IoMdArrowRoundBack } from "react-icons/io";

import { submitFacilityChatRequest, getRequestableFacilities } from '../../../services/chatService';

import FacilityRequests from './requests/FacilityRequests'

const RequestChat = (props) => {
    const { t } = useTranslation()
    const user = useSelector(state => state.login.data)
    const countryId = user ? user.countryId : null;
    const userId = user ? user.id : null;
    const name = user ? user.username : ''
    const token = user ? user.token : null

    const [selectedFacility, setSelectedFacility] = useState(null)
    const [loading, setLoading] = useState(false)
    const [requestLoading, setRequestLoading] = useState(false)
    const [requestSuccess, setRequestSuccess] = useState(null)
    const [requestMessage, setRequestMessage] = useState('')

    const [selectedSection, setSelectedSection] = useState('Contacts') //Contacts or Request Page

    const handleMessageChange = (e) => {
        setRequestMessage(e.target.value)
    }


    const submitRequest = async (facilityId) => {
        setRequestLoading(true)
        const obj = {
            message: requestMessage,
            facilityId: facilityId
        }
        try {
            const result = await submitFacilityChatRequest(token,obj)
            if (result.success) {
                setRequestSuccess(true)
            } else {
                setRequestSuccess(false)
            }
        } catch (err) {
            setRequestSuccess(false)
        } finally {
            setRequestLoading(false)
        }
    }


    return(
        <div className='min-w-full min-h-96 h-full md:h-[450px] lg:h-[500px] grid grid-cols-[1fr] place-items-center md:grid-cols-[210px_1fr] lg:grid-cols-[250px_1fr] xl:grid-cols-[300px_1fr] lg:rounded-br-lg lg:rounded-bl-lg'>
            {/*Message Request */}
            
                <div className={`h-full w-full border-r border-[var(--light-border-color)] overflow-y-auto flex-col items-center justify-start ${selectedSection === 'Contacts' ? 'flex' : 'hidden'} md:flex`}>
                    <FacilityRequests onClick={(item)=>{
                        setRequestSuccess(null)
                        setRequestMessage('')
                        setSelectedFacility(item)
                        setSelectedSection('Request Page')
                    }} />
                </div>


                <div className={`w-full h-full ${selectedSection === 'Request Page' ? 'flex' : 'hidden'} md:flex flex-col items-center justify-center gap-1 px-6 relative`}>
                        <IoMdArrowRoundBack className='absolute top-3 left-4 text-gray-700 h-8 w-8 cursor-pointer md:hidden' onClick={()=>{
                            setSelectedSection('Contacts')
                            setRequestMessage('')
                            }} />

                        {selectedFacility == null ? (<div className='text-gray-400 text-base xl:text-lg '>{t('chat.select_facility')}</div>) 
                        : selectedFacility?.requested ? (<div className="flex flex-col items-center justify-center h-auto mb-3 w-full">
                                <h3 className='text-gray-500 text-lg md:text-xl font-medium'>{selectedFacility?.name}</h3>
                                <p className="text-[var(--secondary-color)] text-base xl:text-lg">{t('chat.already_requested')}</p>
                        </div>) 
                        :
                         (<div className='flex flex-col items-center justify-center h-auto mb-3 w-full'>
                            <h3 className='text-gray-500 text-lg md:text-xl font-medium'>{selectedFacility?.name}</h3>
                            {requestSuccess != true && (<>
                                <input type='text' placeholder={t('chat.enter_request')} value={requestMessage} className='focus:outline-none border border-[var(--light-border-color)] w-11/12 md:w-10/12 mb-4 px-2 py-2 rounded-md' onChange={handleMessageChange}/>
                                <button onClick={()=>submitRequest(selectedFacility.id)} className='text-white flex items-center justify-center w-11/12 md:w-10/12'>
                                    {requestLoading ? <img src='/gray_spinner.svg' className='m-0 h-8 w-8 p-0' /> : t('chat.submit_request')}
                                </button></>)}
                            </div>)}

                            {requestSuccess == false && <p className='text-base text-red-500 font-medium md:text-lg'>{t('chat.request_failed')}</p>}
                            {requestSuccess == true && <p className='text-base text-green-500 font-medium md:text-lg'>{t('chat.request_success')}</p>}
                </div>

        </div>
    )
}

export default RequestChat